/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { InvalidContext } from "cms/common/errors/invalid-context.error";
import { createContext, useContext } from "react";

/** @type {ContentZoneContext} */
const defaultContext = {};
export const ContentZoneContext = createContext(defaultContext);

/**
 * Gets the content zone context
 * @throws An error if the context is empty
 * @returns {ContentZoneContext}
 */
export const useContentZoneContext = () => {
    const context = useContext(ContentZoneContext);

    if (!context) {
        throw new InvalidContext("ContentZoneContext", "ContentZoneContext.Provider");
    }

    return context;
};
